  window.addEventListener('load',()=>{

      const button = document.querySelector('.shape-guide-button')
      const button_scent = document.querySelector('.scent-guide-button')
      const modal = document.querySelector('.shape-guide-modal')
      const modal_scent = document.querySelector('.scent-guide-modal')
      const close = document.querySelector('.shape-guide-modal-close')
      const close_scent = document.querySelector('.scent-guide-modal-close')
      console.log('test', modal)

      //show with fade in animation
      if (button != null) {
        button.onclick = (e) =>{
          modal.classList.add('active')
          setTimeout(()=>{
            modal.classList.add('fade')
          }, 1)
        }
      }
      //show with fade in animation
      if (button_scent != null) {
        button_scent.onclick = (e) =>{
          modal_scent.classList.add('active')
          setTimeout(()=>{
            modal_scent.classList.add('fade')
          }, 1)
        }
      }

      if (modal != null) {
        modal.addEventListener('click', (e) => {
          if(e.target.classList.contains('shape-guide-modal')||e.target.classList.contains('shape-guide-modal-close'))
            modal.classList.remove('fade')
              setTimeout(()=>{
              modal.classList.remove('active')
          },200)
        })
      }

      if (modal_scent != null) {
        modal_scent.addEventListener('click', (e) => {
          if(e.target.classList.contains('scent-guide-modal')||e.target.classList.contains('scent-guide-modal-close'))
            modal_scent.classList.remove('fade')
              setTimeout(()=>{
              modal_scent.classList.remove('active')
          },200)
        })
      }
})